import {useState, useEffect, useCallback, useMemo, useRef} from "react";
import '../../scss/tabs.scss'
import check from '../../images/check.png'
import close from '../../images/close.png'
import tellcellimg from '../../images/tellcell.svg'
import DeliverInfo from '../config/DeliverInfo'
import myAmeriaPay from '../../images/MyAmeriaPayMain.svg'
import ReactGA from 'react-ga';
import bankCard from '../../images/bankCard.png'
import master from '../../images/masterCard.jpg'
import idram2 from '../../images/idram2.png'
import pay from '../../images/pay.png'
import dayjs from 'dayjs';
import TextField from '@mui/material/TextField';
import {DatePicker} from '@mui/x-date-pickers/DatePicker';
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';
import {useTranslation} from "react-i18next";
import {useForm} from 'react-hook-form';
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import {useLocation, useNavigate} from "react-router-dom"
import {Link, useParams} from "react-router-dom"
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';


import Modal from 'react-modal';
import instance from "../../api/axios";

import {Cookies} from 'react-cookie';
import {makeStyles} from "@mui/styles";
import {useCart} from "../../context/CartContext";


const useStyles = makeStyles({
    root: {
        "& label.Mui-focused": {
            color: "#113E2E"
        },
        "& .MuiOutlinedInput-input": {
            color: "#113E2E"
        },

        "& .MuiOutlinedInput-root": {
            "&.Mui-focused fieldset": {
                borderColor: "#113E2E"
            }
        }
    }
});
const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',

    },
};
Modal.setAppElement('#root');

const
    Tabs = () => {
        const navigate = useNavigate()

        const location = useLocation();
        const {t, i18n} = useTranslation()

        const [toggleState, setToggleState] = useState(1);
        const [total, setTotal] = useState([])
        const [filterRadio, setFilterRadio] = useState('')

        const classes = useStyles();
        const {success} = useParams()
        const {fail} = useParams()
        const [paymentId, setPaymentId] = useState('')
        const [ameria, openAmeriaButton] = useState(true)
        const [ameriaopen, setAmeriaOpen] = useState(false)

        const [cartnum, setCartnum] = useState();
        const initialValue = dayjs('10/05/2023');
        const [value1, setValue1] = useState(initialValue);

        const [modalIsOpen, setIsOpen] = useState(false);

        const [isActive, setIsActive] = useState(false);
        const [accordion, setAccordion] = useState(null)
        const [token, setToken] = useState('')

        const [errorToast, setErrorToast] = useState({open: false, message: ""});
        const [redirecting, setRedirecting] = useState(false);
        const [redirectingIdram, setRedirectingIdram] = useState(false);


        const [showResults, setShowResults] = useState('')

        const [selected, setSelect] = useState(false)


        const [lezu, setlezu] = useState('')
        const [submitting, setSubmitting] = useState(false)

        const [orderId, setOrderId] = useState([])

        const [cashorder, setCashorder] = useState('')
        const [cashmail, setCashmail] = useState('')


        const [resPrice, setResPrice] = useState('')
        const [resId, setResId] = useState('')
        const [idram, setidram] = useState([])
        const [openButton, setOpenButton] = useState(true)
        const [someId, setsomeId] = useState('')
        const [ameriaId, setAmeriaId] = useState('')

        const [tellId, setTellId] = useState('')
        const [ameria_pay, setAmeria_pay] = useState([])

        const [tellcell, setTellcell] = useState([])
        const [opentellButton, setOpentellButton] = useState(true)


        const [confirming, setConfirming] = useState(false);


        const {cart, addProduct, decreaseProduct, deleteProduct, removePromocode, applyPromocode} = useCart();
        const cookies = new Cookies();

        let url = process.env.REACT_APP_BASE_URL;


        let subtitle;
        useEffect(() => {
            window.scrollTo(0, 0);
        }, [location]);


        useEffect(() => {
            // tellcell fields exist → auto-submit
            if (tellcell?.issuerField) {
                const form = document.getElementById("tellId");
                if (form) form.submit();
            }
        }, [tellcell]);

        useEffect(() => {
            if (idram?.edp_BILL_NO) {
                const form = document.getElementById("form1");
                if (form) form.submit();
            }
        }, [idram]);


        function openModal() {
            navigate({
                pathname: '/success',
            })
            setIsOpen(true);
        }

        const toggleTab = (index) => {
            setToggleState(index);
        };

        function afterOpenModal() {

            subtitle.style.color = '#0E0E0E';
            subtitle.style.fontSize = '24px';
            subtitle.style.textAlign = 'center';
        }

        function closeModal() {
            navigate({
                pathname: '/tabs',
            })
            setIsOpen(false);
        }


        const toggleaccord = (index) => {

            setAccordion(index);
            setIsActive(!isActive)
        };

        const getChildData = (val) => {
            setToken(val)
        }

        const handlefilter = (event) => {
            setFilterRadio(event.target.value);
        };

        let getActiveCountry = JSON.parse(localStorage.getItem('lng'))
        useEffect(() => {
            getActiveCountry?.filter((item) => {
                if (item.active) {
                    return setlezu(item.name)
                }

            })

        }, [i18n.language])

        const onRemove = async (prod) => {
            try {
                setSubmitting(true);
                await deleteProduct(prod);
            } finally {
                setSubmitting(false);
            }
        };

        const {
            register,
            handleSubmit,

            reset,

            formState: {errors}
        } = useForm()

        const onSubmit1 = async () => {

            if (confirming) return;   // protection
            setConfirming(true);

            ReactGA.event({
                category: "Button",
                action: 'click',
                label: 'Cash'
            });

            let lang = i18n.language.slice(0, 2);
            await instance.post(`${url}/abio/public/cart/confirm?paymentType=CASH&language=${lang}`, {}, {
                headers: {
                    'X_ORDER_XSRF_TOKEN': cookies.get('ORDER_XSRF_TOKEN'),
                },
            })
                .then(el => {
                    setCashorder(el.data.id);
                    setCashmail(el.data.email);
                    setIsOpen(true);

                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({ecommerce: null});
                    window.dataLayer.push({
                        'event': 'purchase',
                        'ecommerce': {
                            'items': el.data.cartProductDTOList.map((product, index) => ({
                                'item_name': product.name_en,
                                'item_id': product.productCode,
                                'price': product.price,
                                'item_list_name': 'cart',
                                'index': index + 1,
                                'quantity': product.quantity
                            }))
                        }
                    });
                })
                .catch(er => {
                    console.log(er);

                    const message = {
                        am: "Տեխնիկական խնդիր է առաջացել, խնդրում ենք կրկին փորձել։",
                        en: "Technical issue, please try again.",
                        ru: "Техническая ошибка, попробуйте снова."
                    }[lang];

                    setErrorToast({open: true, message});
                }).finally(() => {
                    setConfirming(false);
                });
        };

        const onSubmit4 = async () => {

            if (confirming) return;   // protection
            setConfirming(true);

            openAmeriaButton(!ameria);
            let lang = i18n.language.slice(0, 2);

            await instance.post(`${url}/abio/public/cart/confirm?paymentType=AMERIA&language=${lang}`, {}, {
                headers: {
                    'X_ORDER_XSRF_TOKEN': cookies.get('ORDER_XSRF_TOKEN'),
                },
            })
                .then(el => {
                    setPaymentId(el.data.ameria_dto.paymentID);
                    setAmeriaOpen(true);

                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({ecommerce: null});
                    window.dataLayer.push({
                        'event': 'purchase',
                        'ecommerce': {
                            'items': el.data.cartProductDTOList.map((product, index) => ({
                                'item_name': product.name_en,
                                'item_id': product.productCode,
                                'price': product.price,
                                'item_list_name': 'cart',
                                'index': index + 1,
                                'quantity': product.quantity
                            }))
                        }
                    });
                }).catch(er => {
                    console.log(er);

                    const message = {
                        am: "Տեխնիկական խնդիր է առաջացել, խնդրում ենք կրկին փորձել։",
                        en: "Technical issue, please try again.",
                        ru: "Техническая ошибка, попробуйте снова."
                    }[lang];

                    setErrorToast({open: true, message});
                }).finally(() => {
                    setConfirming(false);
                });
        };

        if (ameriaopen) {
            let lang = i18n.language.slice(0, 2);
            window.open(`https://services.ameriabank.am/VPOS/Payments/Pay?id=${paymentId}&lang=@${lang}`, "_self");
            setAmeriaOpen(false);
        }

        const onSubmit2 = async () => {
            if (confirming) return;
            setConfirming(true);

            setOpenButton(!openButton);
            let lang = i18n.language.slice(0, 2);
            await instance.post(`${url}/abio/public/cart/confirm?paymentType=IDRAM&language=${lang}`, {}, {
                headers: {
                    'X_ORDER_XSRF_TOKEN': cookies.get('ORDER_XSRF_TOKEN'),
                },
            })
                .then(el => {
                    setidram(el.data.idram_dto);
                    setResId(el.data.id);
                    setResPrice(el.data.total_price);

                    setRedirectingIdram(true);
                }).catch(er => {
                    console.log(er);

                    const message = {
                        am: "Տեխնիկական խնդիր է առաջացել, խնդրում ենք կրկին փորձել։",
                        en: "Technical issue, please try again.",
                        ru: "Техническая ошибка, попробуйте снова."
                    }[lang];

                    setErrorToast({open: true, message});
                }).finally(() => {
                    setConfirming(false);
                });

        };

        const onSubmit3 = async () => {

            if (confirming) return;
            setConfirming(true);

            let lang = i18n.language.slice(0, 2);
            await instance.post(`${url}/abio/public/cart/confirm?paymentType=TELLCELL&language=${lang}`, {}, {
                headers: {
                    'X_ORDER_XSRF_TOKEN': cookies.get('ORDER_XSRF_TOKEN'),
                },
            })
                .then(el => {
                    setTellcell(el.data.tellcell_dto);
                    setRedirecting(true); // show loading screen
                }).catch(er => {
                    console.log(er);

                    const message = {
                        am: "Տեխնիկական խնդիր է առաջացել, խնդրում ենք կրկին փորձել։",
                        en: "Technical issue, please try again.",
                        ru: "Техническая ошибка, попробуйте снова."
                    }[lang];

                    setErrorToast({open: true, message});
                }).finally(() => {
                    setConfirming(false);
                });
        };

        const handleId = (e) => {
            setsomeId(e.target.name)
        }
        const handletelid = (e) => {
            setTellId(e.target.name)
        }
        const handleAmeriaID = (e) => {
            setAmeriaId(e.target.name)
        }

        const removePromo = async (prom) => {
            const xsrf = cookies.get("ORDER_XSRF_TOKEN");
            await removePromocode(prom, xsrf);
        };

        const DeleteProduct = (prod, qu) => {
            deleteProduct(prod, qu);
        };

        const PromoCode = async () => {
            const xsrf = cookies.get("ORDER_XSRF_TOKEN");

            const result = await applyPromocode(showResults, xsrf);

            if (!result.success) {
                const lang = i18n.language.slice(0, 2);

                const message =
                    result.error === "INVALID_PROMO"
                        ? {
                            am: "Անվավեր պրոմոկոդ։",
                            en: "Invalid promo code.",
                            ru: "Неверный промокод.",
                        }[lang]
                        : {
                            am: "Տեխնիկական խնդիր, խնդրում ենք կրկին փորձել։",
                            en: "Technical issue, please try again.",
                            ru: "Техническая ошибка, попробуйте снова.",
                        }[lang];

                setErrorToast({open: true, message});

            }

            // SUCCESS → nothing to do, cart is updated from context
        };


        useEffect(() => {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ecommerce: null});

            if (toggleState === 1) {
                window.dataLayer.push({
                    'event': 'view_cart',
                    'ecommerce': {
                        'items': cart?.cartProductDTOList?.map((item) => ({
                            'item_name': item.name_en,
                            'item_id': item.productCode,
                            'price': item.price,
                            'item_variant': item.color,
                            'quantity': item.quantity,
                            'discount': item.discountPrice,
                        }))
                    }
                });
            } else if (toggleState === 2) {
                window.dataLayer.push({
                    'event': 'begin_checkout',
                    'ecommerce': {
                        'items': cart?.cartProductDTOList?.map((item) => ({
                            'item_name': item.name_en,
                            'item_id': item.productCode,
                            'price': item.price,
                            'item_variant': item.color,
                            'quantity': item.quantity,
                            'discount': item.discountPrice,
                        }))
                    }
                });
            } else if (toggleState === 3) {
                window.dataLayer.push({
                    'event': 'add_payment_info',
                    'ecommerce': {
                        'items': cart?.cartProductDTOList?.map((item) => ({
                            'item_name': item.name_en,
                            'item_id': item.productCode,
                            'price': item.price,
                            'item_variant': item.color,
                            'quantity': item.quantity,
                            'discount': item.discountPrice,
                        }))
                    }
                });
            }
        }, [toggleState, cart]);

        // useEffect(() => {
        //     DelRegion()
        //
        //
        // }, []);

        const onblur = () => {
            setSelect(!selected)
        }
        const getInput = (e) => {
            setShowResults(e.target.value);
        };


        const onfocus = () => {
            setSelect(selected)
        }


        const handlePayClick = async () => {

            if (confirming) return;
            setConfirming(true);

            setOpentellButton(!opentellButton);
            let lang = i18n.language.slice(0, 2);
            await instance.post(`${url}/abio/public/cart/confirm?paymentType=MY_AMERIA&language=${lang}`, {}, {
                headers: {
                    'X_ORDER_XSRF_TOKEN': cookies.get('ORDER_XSRF_TOKEN'),
                },
            })
                .then(el => {
                    setAmeria_pay(el.data.my_ameria_dto);
                    setResId(el.data.id);
                    setResPrice(el.data.total_price);

                    const paymentUrl = `https://app.myameria.am/pay/getpaymentoptions?merchantName=${el.data.my_ameria_dto.merchantName}&transactionAmount=${el.data.total_price}&transactionId=${el.data.my_ameria_dto.transactionId}&merchantId=${el.data.my_ameria_dto.merchantId}&terminalId=${el.data.my_ameria_dto.terminalId}&callbackscheme=abio.am`;

                    window.open(paymentUrl, "_self");
                }).catch(er => {
                    console.log(er);

                    const message = {
                        am: "Տեխնիկական խնդիր է առաջացել, խնդրում ենք կրկին փորձել։",
                        en: "Technical issue, please try again.",
                        ru: "Техническая ошибка, попробуйте снова."
                    }[lang];

                    setErrorToast({open: true, message});
                }).finally(() => {
                    setConfirming(false);
                });
            ;
        };

        return (
            <>

                <style>
                    {`
        .blur-wrapper {
          filter: blur(3px);
          opacity: 0.6;
          pointer-events: none;
          user-select: none;
          transition: .2s ease;
        }
        `}
                </style>

                <div className="continner">
                    <p className="cardText">{t("cart.yourCart")}</p>
                </div>
                <div className={`cont ${confirming ? "blur-wrapper" : ""}`}>
                    <div className="continner">
                        <div className="bloc-tabs">
                            <button
                                className={toggleState === 1 ? "tabs active-tabs1   " : "tabs  "}
                                onClick={() => toggleTab(1)}
                            >
                                1.{t("cart.yourCart")}
                            </button>
                            <button
                                className={toggleState === 2 ? "tabs active-tabs" : "tabs"}
                                onClick={() => toggleTab(2)}
                            >
                                2. {t("cart.information")}
                            </button>
                            <button
                                className={toggleState === 3 ? "tabs active-tabs2  " : "tabs "}
                                // onClick={() => toggleTab(3)}
                            >
                                3.{t("cart.payment")}
                            </button>

                            <div className="lineborder"></div>

                        </div>

                        <div className="content-tabs">

                            <div
                                className={toggleState === 1 ? "content  active-content" : "content"}
                            >
                                <div className="cont_text">
                                    <div className="first_cont">
                                        <div className="contHeader">


                                            <table>

                                                <thead>
                                                <tr>
                                                    <th>{t("cart.code")}</th>
                                                    <th>{t("cart.details")} </th>
                                                    <th>{t("cart.price")}</th>
                                                    <th>{t("cart.quantity")}</th>
                                                </tr>
                                                </thead>
                                                <tbody>

                                                {cart?.cartProductDTOList?.length > 0 ? cart?.cartProductDTOList?.map((el, i) => {

                                                    return (

                                                        <tr key={el.productCode}>
                                                            <td>
                                                                {el[`selfUrl_${lezu}`] ? (
                                                                    <a
                                                                        href={el[`selfUrl_${lezu}`]}
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                    >
                                                                        {el.productCode}
                                                                    </a>
                                                                ) : (
                                                                    <span>{el.productCode}</span>
                                                                )}
                                                            </td>


                                                            <td className="spacial_cont">

                                                                <img
                                                                    src={`${el?.imageUrl}`}
                                                                    alt=""/>
                                                                <div>
                                                                    <p className="flaxible">{t("cart.code")}: {el.productCode}</p>


                                                                    <p className="changebold">{el?.[`name_${lezu}`]} </p>
                                                                    <div className="span_block">
                                                                        {/* {noCart.find((x) =>  el?.productCode === x?.productCode)?.color ? <> <p>Color:</p>

<p className="span"></p></> : null} */}

                                                                        <img src={close}
                                                                             className="closeimg flaxiblemob"
                                                                             onClick={() => onRemove(el.productCode)}
                                                                             alt="close"/>
                                                                    </div>
                                                                    <p className="flaxible myprice"> {el.discountPrice?.toLocaleString()} AMD</p>
                                                                    <div className="spacial_cont flaxiblemob">

                                                                        <span className="card-minus"
                                                                              onClick={() => decreaseProduct(el.productCode)}>-</span>

                                                                        <p>{el.quantity <= 0 ? el.quantity = 1 : el.quantity}</p>

                                                                        <span className="card-plus"
                                                                              onClick={() => addProduct(el.productCode)}>+</span>

                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td className="forMobile">{el.discountPrice?.toLocaleString()} AMD</td>
                                                            <td className="forMobile">
                                                                <div className="spacial_cont">

                                                                    <span className="card-minus"
                                                                          onClick={() => decreaseProduct(el.productCode)}>-</span>

                                                                    <p>{el.quantity <= 0 ? el.quantity = 1 : el.quantity}</p>

                                                                    <span className="card-plus"
                                                                          onClick={() => addProduct(el.productCode)}>+</span>
                                                                    <img src={close} className="closeimg "
                                                                         onClick={() => onRemove(el.productCode)}
                                                                         alt="close"/>
                                                                </div>

                                                            </td>

                                                        </tr>

                                                    )

                                                }) : (<p className="noTable">{t("cart.noItem")}</p>)}


                                                </tbody>

                                            </table>


                                            <div className="payleft">
                                                <div className="paytitle">
                                                    <p>{t("cart.total")}</p>
                                                    <p>{total.productCode} {cart?.globalDiscountPrice?.toLocaleString()} AMD</p>
                                                </div>
                                                <div className="line"></div>
                                                {cart?.deliveryEnabled ?
                                                    <div className="deliver">
                                                        <p>{t("cart.delivery")}:</p>
                                                        <span>{cart?.deliveryPrice?.toLocaleString()} AMD</span>
                                                    </div> : null
                                                }

                                                <div className="totalPay">
                                                    <p>{t("cart.total")}</p>
                                                    <p>{total.price}{cart?.globalPrice?.toLocaleString()} AMD</p>
                                                </div>

                                                <div className="lastbtn">

                                                    <button onClick={() => toggleTab(2)}> {t("cart.next")}</button>

                                                </div>

                                            </div>
                                        </div>


                                    </div>


                                </div>
                            </div>

                            <div
                                className={toggleState === 2 ? "content  active-content" : "content"}
                            >
                                <DeliverInfo toggleTab={toggleTab} totalPrice={cart?.globalPrice}
                                             getChildData={getChildData} priceGlob={cart?.globalDiscountPrice}
                                             showpromo={cart?.cartProductDTOList?.[0]?.promocode}/>
                            </div>

                            <div
                                className={toggleState === 3 ? "content  active-content" : "content"}
                            >

                                <div className="contLast">

                                    <div>
                                        <div className="cardContent"
                                             onClick={() => toggleaccord(1)}
                                        >
                                            <input type='radio' id="paym"
                                                   checked={filterRadio === '10'}
                                                   value={10}
                                                   onChange={handlefilter}
                                                //  name="paymant"
                                            />
                                            <label htmlFor="paym">
                                                <img src={bankCard} alt="card"/>
                                                <p>{t("cart.bank")}</p>
                                            </label>
                                        </div>

                                        <div className="cardContent" onClick={() => toggleaccord(2)}>
                                            <input type='radio' id="idram"
                                                   checked={filterRadio === '20'}

                                                   value={20}
                                                   onChange={handlefilter}
                                                // name="paymant"
                                            />
                                            <label htmlFor="idram">
                                                <img src={idram2} alt="idram"/>
                                                <p>{t("cart.idram")}</p>
                                            </label>
                                        </div>

                                        <div className={accordion === 2 ? "accord accord-content accord-ss" : "accord"}>
                                            <div className="contCard">
                                                <div>
                                                </div>
                                                {/* <div className="master">
<img src={master}   alt="card" />
</div> */}
                                            </div>

                                        </div>

                                        <div className="cardContent mobile_pay" onClick={() => toggleaccord(5)}>
                                            <input type='radio' id="ameria_pay"
                                                   checked={filterRadio === '50'}
                                                   value={50}
                                                   onChange={handlefilter}
                                            />
                                            <label htmlFor="ameria_pay">
                                                <img src={myAmeriaPay} alt="ameria_pay"/>
                                                <p>{t("cart.ameriaPay")}</p>
                                            </label>
                                        </div>

                                        <div className={accordion === 5 ? "accord accord-content accord-ss" : "accord"}>

                                            <div className="contCard">

                                                <div>


                                                </div>
                                                {/*                                            <div className="master">*/}
                                                {/*<img src={master}   alt="card" />*/}
                                                {/*</div>*/}
                                            </div>


                                        </div>


                                        <div className="cardContent" onClick={() => toggleaccord(4)}>

                                            <input type='radio' id="tellcell"
                                                   checked={filterRadio === '40'}

                                                   value={40}
                                                   onChange={handlefilter}
                                                // name="paymant"
                                            />
                                            <label htmlFor="tellcell">
                                                <img src={tellcellimg} alt="tellcell"/>
                                                <p>{t("cart.tellcell")}</p>
                                            </label>
                                        </div>
                                        <div className={accordion === 4 ? "accord accord-content" : "accord"}></div>
                                        {cart?.deliveryEnabled ?
                                            <>
                                                <div className="cardContent" onClick={() => toggleaccord(3)}>
                                                    <form onSubmit={handleSubmit(onSubmit1)}>
                                                        <label htmlFor="pay">
                                                            <input type='radio' id='pay'
                                                                   checked={filterRadio === '30'}
                                                                   value={30}
                                                                   onChange={handlefilter}
                                                                // name="paymant"
                                                            />

                                                            <img src={pay} alt="pay"/>
                                                            <p>{t("cart.cash")}</p>
                                                        </label>
                                                    </form>
                                                </div>
                                                <div className={accordion === 3 ? "accord accord-content" : "accord"}>

                                                </div>
                                            </> : null}
                                    </div>
                                    <div>
                                        <form id="tellId" action="https://telcellmoney.am/invoices"
                                              method="POST">
                                            <input type="hidden" name="issuer" value={tellcell.issuerField}/>
                                            <input type="hidden" name="action" value={tellcell.actionField}/>
                                            <input type="hidden" name="currency" value={tellcell.currencyField}/>
                                            <input type="hidden" name="price" value={tellcell.priceField}/>
                                            <input type="hidden" name="product" value={tellcell.productField}/>
                                            <input type="hidden" name="issuer_id" value={tellcell.issuer_idField}/>
                                            <input type="hidden" name="valid_days" value={tellcell.valid_daysField}/>
                                            <input type="hidden" name="lang" value={tellcell.langField}/>
                                            <input type="hidden" name="security_code"
                                                   value={tellcell.security_codeField}/>
                                        </form>

                                    </div>


                                    <div className="payleft">
                                        <div className="paytitle">
                                            <p>{t("cart.total")}</p>
                                            <p>{total.productCode} {cart?.globalDiscountPrice?.toLocaleString()} AMD</p>
                                        </div>
                                        <div className="line"></div>
                                        {cart?.deliveryEnabled ?
                                            <div className="deliver">
                                                <p>{t("cart.delivery")}: </p>
                                                <span>{cart?.deliveryPrice?.toLocaleString()} AMD</span>

                                            </div> : null
                                        }

                                        <div className="discount">
                                            <p>{t("cart.discount")}: </p>
                                            <span>
  {(cart?.globalNormalPrice - cart?.globalDiscountPrice)?.toLocaleString()} AMD
</span>

                                        </div>
                                        <div className="totalPay">
                                            <p>{t("cart.total")}</p>
                                            <p>{cart?.globalPrice?.toLocaleString()} AMD</p>
                                        </div>
                                        {cart?.deliveryEnabled ?
                                            <div className="promoCode">


                                                <TextField
                                                    className={classes.root}
                                                    label={t("cart.promo")}
                                                    type='search'
                                                    id='inputAdornedEnd '
                                                    onChange={getInput}


                                                    onBlur={onblur}
                                                    onFocus={onfocus}
                                                    InputProps={{


                                                        className: 'myclass',
                                                        endAdornment: (
                                                            cart?.cartProductDTOList?.[0]?.promoCode == null ?

                                                                (<a className="spanforCheck" id='lav_btn'
                                                                    onClick={PromoCode}>{t("cart.apply")}</a>)
                                                                : <div className="checkedprom"><img src={check}/>
                                                                    <span>{cart?.cartProductDTOList?.[0].promoCode}</span><img
                                                                        width='15px'
                                                                        onClick={() => removePromo(cart?.cartProductDTOList?.[0].promoCode)}
                                                                        className="hidepromo" src={close}/></div>


                                                        ),
                                                    }}

                                                />


                                            </div> : null
                                        }


                                        <div className="lastbtn">

                                            {accordion === 1 &&
                                                <>

                                                    <button
                                                        onClick={onSubmit4}
                                                        className="pay_class"
                                                        type="submit"> {t("cart.next")}</button>


                                                </>
                                            }
                                            {accordion === 3 &&
                                                <button onClick={onSubmit1}
                                                        className="pay_class"
                                                        type="submit"> {t("cart.next")}</button>
                                            }
                                            {accordion === 2 &&
                                                <>
                                                    <button onClick={onSubmit2} className="pay_class">
                                                        {redirectingIdram ? t("cart.idram") : t("cart.next")}
                                                    </button>

                                                </>
                                            }
                                            {accordion === 4 &&
                                                <>
                                                    <button onClick={onSubmit3} className="pay_class">
                                                        {redirecting ? t("cart.tellcell") : t("cart.next")}
                                                    </button>

                                                </>
                                            }

                                            {accordion === 5 &&
                                                <>
                                                    <button
                                                        onClick={handlePayClick}
                                                        type="submit"> {t("cart.next")}</button>
                                                </>
                                            }

                                        </div>
                                    </div>

                                </div>

                                <div>
                                    <form id="form1" action="https://banking.idram.am/Payment/GetPayment" method="POST">
                                        <input type="hidden" name="EDP_LANGUAGE" value={idram?.edp_LANGUAGE}/>
                                        <input type="hidden" name="EDP_REC_ACCOUNT" value={idram?.edp_REC_ACCOUNT}/>
                                        <input type="hidden" name="EDP_DESCRIPTION" value={idram?.edp_DESCRIPTION}/>
                                        <input type="hidden" name="EDP_AMOUNT" value={idram?.edp_AMOUNT}/>
                                        <input type="hidden" name="EDP_BILL_NO" value={idram?.edp_BILL_NO}/>
                                        {/* <input type="submit" className="continuShop" value={t("cart.idram")}/> */}
                                    </form>
                                </div>

                                <div>
                                    <form id="form5" action="https://app.myameria.am/pay/getpaymentoptions"
                                          method="GET">
                                        <input type="hidden" name="merchantId" value={ameria_pay?.merchantId}/>
                                        <input type="hidden" name="merchantName" value={ameria_pay?.merchantName}/>
                                        <input type="hidden" name="terminalId" value={ameria_pay?.terminalId}/>
                                        <input type="hidden" name="transactionId" value={resId}/>
                                        <input type="hidden" name="transactionAmount" value={resPrice}/>
                                        <input type="hidden" name="callbackscheme" value="www.abio.am"/>
                                    </form>
                                </div>
                                <Modal
                                    isOpen={modalIsOpen}
                                    onAfterOpen={afterOpenModal}
                                    onRequestClose={closeModal}
                                    ariaHideApp={false}
                                    style={customStyles}

                                >
                                    <div className='modalCont'>
                                        <h2 ref={(_subtitle) => (subtitle = _subtitle)}><input type="checkbox"
                                                                                               className="modalcheck"
                                                                                               checked/>{t("Tabs.thanks")}
                                        </h2>
                                        {/*<button className="closeModal" onClick={closeModal}><img alt="image"*/}
                                        {/*                                                         src={close}/>*/}
                                        {/*</button>*/}
                                    </div>
                                    <div className="modalText" id="pay_ids">{t("Tabs.thanksdetail1")}
                                        <span> {cashorder} </span>
                                        {t("Tabs.thanksdetail2")}
                                        <span>{cashmail}</span></div>
                                    <Link to={`/${i18n.language}`}>
                                        <button className="continuShop">{t("shop.continue")}</button>
                                    </Link>
                                </Modal>

                            </div>
                        </div>
                    </div>
                </div>

                <Snackbar
                    open={errorToast.open}
                    autoHideDuration={4000}
                    onClose={() => setErrorToast({...errorToast, open: false})}
                >
                    <MuiAlert severity="error" sx={{width: '100%'}}>
                        {errorToast.message}
                    </MuiAlert>
                </Snackbar>

            </>
        );
    }

export {Tabs};